import React, { useState, useEffect, useContext, useMemo } from "react";
import { UserContext } from "../UserContext";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer";
import AdminNav from "../Navbars/AdminNav";
import axios from "axios";
import { toast } from "react-toastify";
import "./PolymatchInvoice.css";
import axiosInstance from "./axiosInstance";
import Select from 'react-select';
import countryList from 'react-select-country-list';
import { FaSearch } from "react-icons/fa";

const highlightText = (text, highlight) => {
  if (!highlight.trim()) return text;
  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = (text || "").toString().split(regex);
  return parts.map((part, i) =>
    regex.test(part) ? (
      <span key={i} className="search-highlight">
        {part}
      </span>
    ) : (
      part
    )
  );
};

function PolymatchInvoices() {
  const [invoices, setInvoices] = useState(() => {
    const saved = sessionStorage.getItem("savedInvoices");
    return saved ? JSON.parse(saved) : [];
  });
  const [loading, setLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState(() => sessionStorage.getItem("filterStatus") || "All");
  const [showInvoices, setShowInvoices] = useState(() => sessionStorage.getItem("showInvoices") === "true");
  const [filterCompetition, setFilterCompetition] = useState(() => sessionStorage.getItem("filterCompetition") || "All");
  const [searchTerm, setSearchTerm] = useState(() => sessionStorage.getItem("searchTerm") || "");
  const [editingInvoice, setEditingInvoice] = useState(null); // ye modal me edit karne ke liye
  const [modalOpen, setModalOpen] = useState(false);
  const [competitions, setCompetitions] = useState([]);
  const [sending, setSending] = useState(false);
  const { isAdmin, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  const navigate = useNavigate();
  const [filterCountry, setFilterCountry] = useState(() => sessionStorage.getItem("filterCountry") || "All");
  const [filterCurrency, setFilterCurrency] = useState(() => sessionStorage.getItem("filterCurrency") || "All");
  const [ageGroups, setAgeGroups] = useState([]);
  const [filterAgeGroup, setFilterAgeGroup] = useState(() => sessionStorage.getItem("filterAgeGroup") || "All");
  const [bankDetails, setBankDetails] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [noteValue, setNoteValue] = useState(sessionStorage.getItem("Note") || process.env.REACT_APP_NOTE_INVOICE);
  const [USDValue, setUSDValue] = useState(sessionStorage.getItem("USD") || process.env.REACT_APP_Amount_In_USD);
  const [USDTValue, setUSDTValue] = useState(sessionStorage.getItem("USDT") || process.env.REACT_APP_Transaction_Fee_USD);
  const [PKRValue, setPKRValue] = useState(sessionStorage.getItem("PKR") || process.env.REACT_APP_Amount_In_PKR);
  const [PKRTValue, setPKRTValue] = useState(sessionStorage.getItem("PKRT") || process.env.REACT_APP_Transaction_Fee_PKR);
  useEffect(() => {
    if (editingInvoice && bankDetails.length > 0) {
      const selectedFromBackend = bankDetails
        .filter(b => editingInvoice.bank_id?.includes(b.id.toString()))
        .map(b => ({ label: b.details, value: b.id.toString() }));

      setSelectedAccounts(selectedFromBackend);
    }
  }, [editingInvoice, bankDetails]);

  useEffect(() => {
    fetchUserInfo();
    // fetchInvoices(); // Manual load only
  }, []);

  // Auto-fetch if showing invoices but list is empty (e.g. from search/filter)
  useEffect(() => {
    if (showInvoices && invoices.length === 0 && filterCompetition === "All" && !loading) {
      fetchInvoices();
    }
  }, [showInvoices]);

  // ✅ Persist state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem("savedInvoices", JSON.stringify(invoices));
    sessionStorage.setItem("showInvoices", showInvoices);
    sessionStorage.setItem("filterStatus", filterStatus);
    sessionStorage.setItem("filterCompetition", filterCompetition);
    sessionStorage.setItem("filterCountry", filterCountry);
    sessionStorage.setItem("filterCurrency", filterCurrency);
    sessionStorage.setItem("filterAgeGroup", filterAgeGroup);
    sessionStorage.setItem("searchTerm", searchTerm);
  }, [invoices, showInvoices, filterStatus, filterCompetition, filterCountry, filterCurrency, filterAgeGroup, searchTerm]);

  // Row color: payment (green) takes priority, otherwise sent-mail (yellow)
  const getRowColor = (invoice) => {
    if (invoice.Payment_recieved == 1 || invoice.Payment_recieved === true) {
      return "#c8f7c5"; // green
    } else if (invoice.Sent_mail == 1 || invoice.Sent_mail === true) {
      return "#fff6a6"; // yellow
    }
    return "white";
  };

  useEffect(() => {
    const fetchAgeGroups = async () => {
      try {
        const res = await axiosInstance.get("/polymatcAgeGroup"); // your backend API
        // res.data.data assumed to be array of { Agegroup_Id, Competition_Id, Display_Name }
        setAgeGroups(res.data.data || []);
      } catch (err) {
        console.error("Failed to fetch age groups", err);
        toast.error("Failed to fetch age groups");
      }
    };
    fetchAgeGroups();
  }, []);


  const fetchUserInfo = async () => {
    try {
      const response = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: "include",
      });
      const data = await response.json();
      setUserInfo(data);
      if (data?.usertype) {
        setUserRole(data.usertype);
      }
    } catch (error) {
      console.log("Error in fetchUserInfo:", error);
    }
  };

  useEffect(() => {
    const fetchBankDetails = async () => {
      try {
        const res = await axiosInstance.get("/bankdetails");
        console.log("Bank details response:", res.data);
        setBankDetails(res.data);  // assume bank list array aa raha
      } catch (err) {
        console.log("Bank details fetch error:", err);
      }
    };

    fetchBankDetails();
  }, []);

  //  Fetch invoices from backend
  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/polymatchregister", {
        params: {
          competitionId: filterCompetition === "All" ? null : filterCompetition
        }
      });
      const data = response.data?.data || [];
      const sortedData = data.sort((a, b) => b.Participant_id - a.Participant_id);

      const formatted = sortedData.map((item) => {
        // Show 0 for EVERYONE by default. Only show amount if it was explicitly set in DB (via Edit).
        const amount = item.amount ? item.amount : "0";

        return {
          id: (item.Invoice_Id && item.Invoice_Id.trim()) || item.Participant_id,
          Username: item.Username,
          clientName: `${item.First_name}`,
          competitionName: item.Competition_Name,
          Whatsapp_number: item.Contact_Num,
          competitionId: item.Competition_Id,
          Agegroup_Id: item.Agegroup_Id,
          Last_name: item.Last_name,
          Parent_name: item.Parent_name,
          Address: item.Address,
          school: item.school,
          City: item.City,
          Age: item.Age,
          bank_id: item.bank_id,
          Country: item.Country,
          Email: item.Email,
          img: item.img,
          Payment_recieved: item.Payment_Recieved,
          Sent_mail: item.Sent_mail,
          amount,
          date: item.Issue_Date,
          dueDate: item.Due_Date,
          status: item.Payment_Recieved ? "Paid" : "Pending",
          filePath: item.File_Path,
          Participant_id: item.Participant_id,
        };
      });

      setInvoices(formatted);
    } catch (error) {
      console.error("Error fetching invoices:", error);
      toast.error("Failed to fetch invoices!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, [filterCompetition]); // Fetch when competition filter changes
  // ✅ Filtering and helpers

  // Set showInvoices to true whenever a filter is applied

  const handleStatusFilter = (status) => {
    setFilterStatus(status);
    setShowInvoices(true);
  };
  const handleCompetitionFilter = (competition) => {
    setFilterCompetition(competition);
    setFilterAgeGroup("All"); // Reset age group as it's competition-specific
    setShowInvoices(true);
  };
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    // Don't necessarily show all just by typing, but usually user expects results
    setShowInvoices(true);
  };

  const handleCountryFilter = (country) => {
    setFilterCountry(country);
    setShowInvoices(true);
  };

  const handleCurrencyFilter = (currency) => {
    setFilterCurrency(currency);
    setShowInvoices(true);
  };

  const handleAgeGroupFilter = (ageDetails) => {
    setFilterAgeGroup(ageDetails);
    setShowInvoices(true);
  };

  const handleLoadAll = () => {
    setFilterStatus("All");
    setFilterCompetition("All");
    setFilterCountry("All");
    setFilterCurrency("All");
    setFilterAgeGroup("All");
    setSearchTerm("");
    setShowInvoices(true);
  };




  const handleView = (invoiceId) => {
    navigate(`/invoice/${invoiceId}`);
    toast.info(`Viewing invoice ${invoiceId}`, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const handleCloseInvoices = () => {
    setShowInvoices(false);
    setInvoices([]);
    setFilterStatus("All");
    setFilterCompetition("All");
    setFilterCountry("All");
    setFilterCurrency("All");
    setFilterAgeGroup("All");
    setSearchTerm("");

    // ✅ Clear persistent storage on close
    sessionStorage.removeItem("savedInvoices");
    sessionStorage.removeItem("showInvoices");
    sessionStorage.removeItem("filterStatus");
    sessionStorage.removeItem("filterCompetition");
    sessionStorage.removeItem("filterCountry");
    sessionStorage.removeItem("filterCurrency");
    sessionStorage.removeItem("filterAgeGroup");
    sessionStorage.removeItem("searchTerm");
  };

  // const handleEdit = (invoiceId) => {
  //   navigate(`/edit-invoice/${invoiceId}`);
  //   toast.info(`Editing invoice ${invoiceId}`, {
  //     position: toast.POSITION.TOP_RIGHT,
  //   });
  // };

  const handleEditClick = (invoice) => {
    setEditingInvoice(invoice); // select invoice for modal
    setModalOpen(true);         // modal open karo
  };

  const [saving, setSaving] = useState(false);

  const handleDelete = async (invoiceId) => {
    console.log("👉 Delete button clicked for invoice ID:", invoiceId);
    if (window.confirm("Are you sure you want to delete this invoice? This action cannot be undone.")) {
      console.log("👉 User confirmed deletion");
      try {
        console.log("👉 Calling DELETE API:", `/polymatchregister/${invoiceId}`);
        await axiosInstance.delete(`/polymatchregister/${invoiceId}`);
        console.log("👉 Delete API successful");
        toast.success("Invoice deleted successfully");
        setInvoices(invoices.filter(inv => inv.id !== invoiceId));
      } catch (error) {
        console.error("❌ Delete error:", error);
        console.error("❌ Error response:", error.response?.data);
        toast.error("Failed to delete invoice");
      }
    } else {
      console.log("👉 User cancelled deletion");
    }
  };

  const handleSaveModal = async (e) => {
    e.preventDefault(); // page reload stop
    if (saving) return;  // already saving, prevent double click

    setSaving(true);
    try {
      const updatedInvoice = { ...editingInvoice };

      // Ensure backend names are used
      updatedInvoice.Issue_Date = updatedInvoice.date;
      updatedInvoice.Due_Date = updatedInvoice.dueDate;

      // Optional: Add a small safeguard for 1970 just in case,
      // but the manual fields should prevent this.
      const currentIssueDate = new Date(updatedInvoice.Issue_Date);
      if (!updatedInvoice.Issue_Date || isNaN(currentIssueDate.getTime()) || currentIssueDate.getFullYear() <= 1970) {
        const now = new Date();
        updatedInvoice.Issue_Date = now.toISOString().slice(0, 10);

        const due = new Date(now);
        due.setDate(now.getDate() + 2);
        updatedInvoice.Due_Date = due.toISOString().slice(0, 10);
      }

      await axiosInstance.put(`/polymatchregister/${updatedInvoice.id}`, updatedInvoice);

      // Toast ek baar
      toast.success("Invoice updated successfully!", { toastId: "updateInvoice" });

      // Modal close
      setModalOpen(false);

      // API se fresh invoices fetch karo
      fetchInvoices();

    } catch (error) {
      console.error("Update error:", error);
      const msg = error.response?.data?.message || "Update failed!";
      toast.error(msg, { toastId: "updateInvoiceError" });
    } finally {
      setSaving(false);
    }
  };

  const filteredAgeGroups = useMemo(() => {
    if (filterCompetition === "All") return ageGroups; // show all if no competition selected
    return ageGroups.filter(ag => ag.Competition_Id == filterCompetition);
  }, [ageGroups, filterCompetition]);

  const downloadImage = async (url, Username) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${Username}.jpg`;  // <-- Working file name!
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };
  const handleSendInvoice = async () => {
    if (!editingInvoice) {
      toast.error("No invoice selected!");
      return;
    }

    setSending(true);

    try {
      const response = await axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/send-invoice`, {
        invoiceNumber: editingInvoice.id,
        email: editingInvoice.Email,
        First_name: editingInvoice.clientName,
      });

      if (response.status === 200) {
        toast.success("Invoice sent successfully!");
        console.log("Invoice API Response:", response.data);
        setModalOpen(false); // close modal only after success
        fetchInvoices();     // refresh table after send
      } else {
        toast.error("Failed to send invoice");
      }
    } catch (error) {
      console.error("Error sending invoice:", error);
      toast.error("Something went wrong while sending invoice");
    }
  };

  const countryOptionsFullName = countryList()
    .getData()
    .map(c => ({ label: c.label, value: c.label }));


  const formatDate = (dateString, status) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    const date = new Date(dateString);

    // If date is invalid or 1970 (unix epoch 0)
    if (isNaN(date.getTime()) || date.getFullYear() <= 1970) {
      if (status === "Pending") {
        // For Pending, show Today as a preview/default
        return new Date().toLocaleDateString(undefined, options);
      } else {
        // For Paid (historical data with missing dates), show a dash
        return "-";
      }
    }
    return date.toLocaleDateString(undefined, options);
  };

  // const formatCurrency = (amount) => {
  //   return new Intl.NumberFormat('en-US', {
  //     style: 'currency',
  //     currency: 'USD'
  //   }).format(amount);
  // };

  const getStatusBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case 'paid':
        return 'status-paid';
      case 'pending':
        return 'status-pending';
      case 'overdue':
        return 'status-overdue';
      default:
        return 'status-default';
    }
  };

  // Get unique competition names for filter
  const competitionNames = [...new Set(invoices.map(invoice => invoice.competitionName))];

  // Filter invoices based on status, competition and search term
  const filteredInvoices = invoices.filter(invoice => {
    const matchesStatus = filterStatus === "All" || invoice.status === filterStatus;
    const matchesCompetition = filterCompetition === "All" || invoice.competitionId == filterCompetition;
    const matchesCountry = filterCountry === "All" || invoice.Country === filterCountry;

    let matchesCurrency = true;
    if (filterCurrency === "PKR") matchesCurrency = invoice.Country === "Pakistan";
    if (filterCurrency === "USD") matchesCurrency = invoice.Country !== "Pakistan";

    const matchesSearch =
      (invoice.clientName || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (invoice.Last_name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (invoice.Username || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (invoice.Email || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (invoice.school || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (invoice.Whatsapp_number || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (invoice.id + "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (invoice.competitionName || "").toLowerCase().includes(searchTerm.toLowerCase());

    // 🔹 Matches age group
    let matchesAgeGroup = true;
    if (filterAgeGroup !== "All") {
      matchesAgeGroup = invoice.Agegroup_Id != null && invoice.Agegroup_Id == filterAgeGroup;
      // Competition match is already handled by filteredInvoices filter
    }
    return matchesStatus && matchesCompetition && matchesCountry && matchesCurrency && matchesSearch && matchesAgeGroup;
  });


  const onLogout = () => {
    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: "include",
      method: "POST",
    })
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
    setUserInfo(null);
    setUserRole("guest");
  };

  // Backend se competitions fetch karo
  useEffect(() => {
    const fetchCompetitions = async () => {
      try {
        const res = await axiosInstance.get("/polymatch_competitions"); // backend API
        setCompetitions(res.data.data); // assume data array aa raha hai
      } catch (err) {
        console.error("Failed to fetch competitions", err);
      }
    };
    fetchCompetitions();
  }, []);

  // Consolidating fetchFilteredInvoices into fetchInvoices

  const username = userInfo?.username;

  return (
    <>
      {username && isAdmin && <AdminNav username={username} onLogout={onLogout} />}

      {modalOpen && editingInvoice && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 999,
          overflowY: "auto",  // allow scroll if content taller than screen
          padding: "20px",    // space around modal on small screens
        }}>
          <div style={{
            background: "#fff",
            padding: "20px",
            width: "400px",
            maxWidth: "100%",
            maxHeight: "90vh",  // modal max height
            overflowY: "auto",  // scroll inside modal
            boxSizing: "border-box",

          }}>
            <h3 style={{ marginBottom: "15px" }}>Invoice # {editingInvoice.id}</h3>

            <label>First Name</label>
            <input
              type="text"
              value={editingInvoice.clientName}
              onChange={(e) => setEditingInvoice({ ...editingInvoice, clientName: e.target.value })}
              style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
            />

            <label>Last Name</label>
            <input
              type="text"
              value={editingInvoice.Last_name}
              onChange={(e) => setEditingInvoice({ ...editingInvoice, Last_name: e.target.value })}
              style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
            />

            <label>Parent_name</label>
            <input
              type="text"
              value={editingInvoice.Parent_name}
              onChange={(e) => setEditingInvoice({ ...editingInvoice, Parent_name: e.target.value })}
              style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
            />

            <label>Whatsapp_number</label>
            <input
              type="text"
              value={editingInvoice.Whatsapp_number}
              onChange={(e) => setEditingInvoice({ ...editingInvoice, Whatsapp_number: e.target.value })}
              style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
            />

            <label>Age</label>
            <input
              type="text"
              value={editingInvoice.Age}
              onChange={(e) => setEditingInvoice({ ...editingInvoice, Age: e.target.value })}
              style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
            />

            <label>Email</label>
            <input
              type="text"
              value={editingInvoice.Email}
              onChange={(e) => setEditingInvoice({ ...editingInvoice, Email: e.target.value })}
              style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
            />

            <label>school</label>
            <input
              type="text"
              value={editingInvoice.school}
              onChange={(e) => setEditingInvoice({ ...editingInvoice, school: e.target.value })}
              style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
            />

            <label>City</label>
            <input
              type="text"
              value={editingInvoice.City}
              onChange={(e) => setEditingInvoice({ ...editingInvoice, City: e.target.value })}
              style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
            />



            <label>Country</label>
            <Select
              name="country"
              placeholder="Choose your country *"
              value={countryOptionsFullName.find(option => option.value === editingInvoice.Country)}
              options={countryOptionsFullName}
              onChange={(option) => setEditingInvoice({ ...editingInvoice, Country: option.value })}
              isDisabled={saving || sending}
            />

            <label>Account details</label>
            <Select
              isMulti
              options={bankDetails.map(b => ({ label: b.details, value: b.id.toString() }))}
              value={selectedAccounts}   // ye ab selected dikhaega
              onChange={(selected) => {
                setSelectedAccounts(selected);
                setEditingInvoice({
                  ...editingInvoice,
                  bank_id: selected.map(s => s.value.toString()),
                });
              }}
              placeholder="Select Account"
            />

            <label>Address</label>
            <input
              type="text"
              value={editingInvoice.Address}
              onChange={(e) => setEditingInvoice({ ...editingInvoice, Address: e.target.value })}
              style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
            />
            <div className="modal-input-group">
              <label>Note</label>
              <input
                type="text"
                value={noteValue}
                onChange={(e) => {
                  const value = e.target.value;
                  setNoteValue(value);
                  sessionStorage.setItem("Note", value);
                }}
              />
            </div>

            <div className="modal-input-group">
              <label>PKR amount</label>
              <input
                type="text"
                value={PKRValue}
                onChange={(e) => {
                  const value = e.target.value;
                  setPKRValue(value);
                  sessionStorage.setItem("PKR", value);
                }}
              />
            </div>

            <div className="modal-input-group">
              <label>PKR Transaction amount</label>
              <input
                type="text"
                value={PKRTValue}
                onChange={(e) => {
                  const value = e.target.value;
                  setPKRTValue(value);
                  sessionStorage.setItem("PKRT", value);
                }}
              />
            </div>

            <div className="modal-input-group">
              <label>USD amount</label>
              <input
                type="text"
                value={USDValue}
                onChange={(e) => {
                  const value = e.target.value;
                  setUSDValue(value);
                  sessionStorage.setItem("USD", value);
                }}
              />
            </div>

            <div className="modal-input-group">
              <label>USD Transaction amount</label>
              <input
                type="text"
                value={USDTValue}
                onChange={(e) => {
                  const value = e.target.value;
                  setUSDTValue(value);
                  sessionStorage.setItem("USDT", value);
                }}
              />
            </div>

            <div className="modal-input-group">
              <label>Issue Date</label>
              <input
                type="date"
                value={(() => {
                  if (!editingInvoice.date) return new Date().toISOString().split('T')[0];
                  const d = new Date(editingInvoice.date);
                  if (isNaN(d.getTime()) || d.getFullYear() <= 1970) return new Date().toISOString().split('T')[0];
                  return d.toISOString().split('T')[0];
                })()}
                onChange={(e) => {
                  const newIssueDate = e.target.value;
                  const newDueDate = new Date(newIssueDate);
                  newDueDate.setDate(newDueDate.getDate() + 2);
                  setEditingInvoice({
                    ...editingInvoice,
                    date: newIssueDate,
                    dueDate: newDueDate.toISOString().split('T')[0]
                  });
                }}
              />
            </div>

            <div className="modal-input-group">
              <label>Due Date</label>
              <input
                type="date"
                value={(() => {
                  if (!editingInvoice.dueDate) {
                    const d = new Date();
                    d.setDate(d.getDate() + 2);
                    return d.toISOString().split('T')[0];
                  }
                  const d = new Date(editingInvoice.dueDate);
                  if (isNaN(d.getTime()) || d.getFullYear() <= 1970) {
                    const issue = new Date(editingInvoice.date || new Date());
                    issue.setDate(issue.getDate() + 2);
                    return issue.toISOString().split('T')[0];
                  }
                  return d.toISOString().split('T')[0];
                })()}
                onChange={(e) => setEditingInvoice({ ...editingInvoice, dueDate: e.target.value })}
              />
            </div>





            {/* <label>Payment Received</label>
      <input
        type="checkbox"
        checked={editingInvoice.Payment_recieved}
        onChange={(e) => setEditingInvoice({...editingInvoice, Payment_recieved: e.target.checked})}
        style={{ marginLeft: "10px" }}
      /> */}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "15px" }}>
              <button
                onClick={handleSendInvoice}   // 🔹 Don’t put parentheses or any variable here
                disabled={sending}            // ✅ Disable when sending
                style={{
                  backgroundColor: sending ? "#d4b91f" : "#f0d125ff",
                  color: "#fff",
                  padding: "7px 12px",
                  fontSize: "15px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: sending ? "not-allowed" : "pointer",
                  opacity: sending ? 0.7 : 1
                }}
              >
                {sending ? "Sending..." : "Send Mail"}
              </button>

              <button
                onClick={handleSaveModal}
                disabled={saving}
                style={{
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  padding: "7px 12px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer"
                }}
              >
                {saving ? "Saving..." : "Save"}
              </button>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  backgroundColor: "#f44336",
                  color: "#fff",
                  padding: "7px 12px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer"
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}


      <div className="polymatch-invoices-container">
        <h2 className="ppage-title text-center">Polymatch Invoices</h2>



        {/* Status Buttons Row (Restored) */}
        <div className="status-row">
          <div className="status-filters">
            <button
              className={`filter-btn ${filterStatus === "All" ? "active" : ""}`}
              onClick={() => handleStatusFilter("All")}
            >
              All Invoices
            </button>
            <button
              className={`filter-btn ${filterStatus === "Paid" ? "active" : ""}`}
              onClick={() => handleStatusFilter("Paid")}
            >
              Paid
            </button>
            <button
              className={`filter-btn ${filterStatus === "Pending" ? "active" : ""}`}
              onClick={() => handleStatusFilter("Pending")}
            >
              Pending
            </button>
          </div>
        </div>

        {/* Other Filters Row */}
        <div className="filters-row">
          <select
            className="filter-select"
            value={filterCompetition}
            onChange={(e) => handleCompetitionFilter(e.target.value)}
          >
            <option value="All">All Competitions</option>
            {competitions.map(c => (
              <option key={c.Competition_Id} value={c.Competition_Id}>
                {c.Competition_Name} ({new Date(c.Competition_date).getFullYear()})
              </option>
            ))}
          </select>

          <select
            className="filter-select"
            value={filterCountry}
            onChange={(e) => handleCountryFilter(e.target.value)}
          >
            <option value="All">All Countries</option>
            {countryOptionsFullName.map((c, index) => (
              <option key={index} value={c.value}>
                {c.label}
              </option>
            ))}
          </select>

          <select
            className="filter-select"
            value={filterCurrency}
            onChange={(e) => handleCurrencyFilter(e.target.value)}
          >
            <option value="All">All Currencies</option>
            <option value="PKR">PKR (₨)</option>
            <option value="USD">USD ($)</option>
          </select>

          <select
            className="filter-select"
            value={filterAgeGroup}
            onChange={(e) => handleAgeGroupFilter(e.target.value)}
          >
            <option value="All">All Age Groups</option>
            {filteredAgeGroups.map(ag => (
              <option key={ag.Agegroup_Id} value={ag.Agegroup_Id}>
                {ag.Display_Name}
              </option>
            ))}
          </select>
        </div>

        {/* Top Row: Search + Stats 3 parts, moved below filters */}
        <div className="invoices-top-row">
          <div className="psearch-box">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearch}
              className="psearch-input"
            />
          </div>

          <div className="stat-item total">
            <span className="stat-label">Total Invoices</span>
            <span className="stat-value">{filteredInvoices.length}</span>
          </div>

          <div className="stat-item pending">
            <span className="stat-label">Pending Invoices</span>
            <span className="stat-value">{filteredInvoices.filter(inv => inv.status === 'Pending').length}</span>
          </div>
        </div>

        {/* Load Button Row */}
        {/* Load/Close Actions */}
        {!showInvoices ? (
          <div className="load-invoices-box">
            <h3>Polymatch Invoices</h3>
            <p>Search for a specific invoice or load all available data.</p>
            <button className="btn-load-box" onClick={handleLoadAll}>
              Load All Invoices
            </button>
          </div>
        ) : (
          <div className="load-action-row">
            <button className="btn-close-invoices" onClick={handleCloseInvoices}>
              Close Invoices
            </button>
          </div>
        )}

        {/* Table Section */}
        {showInvoices ? (
          <div className="invoices-table-container">
            {loading ? (
              <div className="loading-spinner">
                <div className="spinner"></div>
                <p>Loading invoices...</p>
              </div>
            ) : (
              <div className="table-wrapper">
                <div className="table-responsive">
                  <table className="invoices-table">
                    <thead>
                      <tr>
                        <th>User Name</th>
                        <th>Student Image</th>
                        <th>Student Name</th>
                        <th>Competition Name</th>
                        <th>Whatsapp_number</th>
                        <th>Age</th>
                        <th>School</th>
                        <th>City</th>
                        <th>Country</th>
                        <th>Email</th>
                        <th>Amount</th>
                        <th>Issue Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                        <th>Invoice_Recieved to_customer</th>
                        <th>Payment_recieved</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredInvoices.length > 0 ? (
                        filteredInvoices.map((invoice, index) => (
                          <tr key={index} className="invoice-row" style={{ backgroundColor: getRowColor(invoice) }}>
                            <td className="invoice-id">{highlightText(invoice.Username, searchTerm)}</td>
                            <td className="client-image">

                              {invoice.img ? (
                                <div className="image-wrapper" onClick={() => downloadImage(invoice.img, invoice.Username)}>
                                  <img
                                    src={invoice.img}
                                    alt={invoice.clientName}
                                    onError={(e) => {
                                      if (!e.target.dataset.triedProduction) {
                                        e.target.dataset.triedProduction = "true";
                                        const productionBase = process.env.REACT_APP_PRODUCTION_IMAGE_URL || "https://backend.polymath-kids.com/public/";
                                        const fileName = invoice.img.split('/').pop();
                                        const fallbackSrc = `${productionBase}Polymatch-reg/${fileName}`;
                                        console.log("Image local load failed, trying production:", fallbackSrc);
                                        e.target.src = fallbackSrc;
                                      } else {
                                        console.error("Production fallback also failed for:", e.target.src);
                                      }
                                    }}
                                    style={{ width: "70px", height: "70px", objectFit: "cover", borderRadius: "50%" }}
                                  />
                                  <div className="download-icon">⬇</div>
                                </div>
                              ) : (
                                <span>No Image</span>
                              )}
                            </td>
                            <td className="client-name">
                              {highlightText(`${invoice.clientName} ${invoice.Last_name || ""}`, searchTerm)}
                            </td>
                            <td className="competition-name">{highlightText(invoice.competitionName, searchTerm)}</td>
                            <td className="Whatsapp_number">{highlightText(invoice.Whatsapp_number, searchTerm)}</td>
                            <td className="Age">{invoice.Age}</td>
                            <td className="school">{highlightText(invoice.school, searchTerm)}</td>
                            <td className="City">{highlightText(invoice.City, searchTerm)}</td>
                            <td className="Country">{invoice.Country}</td>
                            <td className="Email">{highlightText(invoice.Email, searchTerm)}</td>
                            <td className="amount">{(invoice.amount)}</td>
                            <td className="date">{formatDate(invoice.date, invoice.status)}</td>
                            {/* <td className="items">{invoice.items} items</td> */}
                            <td>
                              <span className={`status-badge ${getStatusBadgeClass(invoice.status)}`}>
                                {invoice.status}
                              </span>
                            </td>
                            <td className="actions">
                              <button
                                className="btn-view"
                                onClick={() => handleView(invoice.id)}
                              >
                                👁️ View
                              </button>
                              <button
                                className="btn-edit"
                                onClick={() => handleEditClick(invoice)}
                              >
                                ✏️ Edit
                              </button>
                            </td>

                            <td className="Send">
                              <input
                                type="checkbox"
                                checked={invoice.Sent_mail === 1 || invoice.Sent_mail === true}
                                onChange={async (e) => {
                                  const newValue = e.target.checked ? 1 : 0;
                                  try {
                                    // 1. Send API request to update payment
                                    await axiosInstance.put(`/invoicestatus/${invoice.id}`, {
                                      Sent_mail: newValue
                                    });

                                    // 2. Update frontend state immediately
                                    setInvoices((prevInvoices) =>
                                      prevInvoices.map((inv) =>
                                        inv.id === invoice.id ? { ...inv, Sent_mail: newValue } : inv
                                      )
                                    );

                                    toast.success(newValue ? `Email recived tu customer Successfully` : `Email status updated`);
                                  } catch (error) {
                                    console.error("Failed to update payment:", error);
                                    toast.error("Failed to update payment");
                                  }
                                }}
                              />
                            </td>
                            <td className="Payment_recieved">
                              <input
                                type="checkbox"
                                checked={invoice.Payment_recieved === 1 || invoice.Payment_recieved === true}
                                onChange={async (e) => {
                                  const newValue = e.target.checked ? 1 : 0;
                                  try {
                                    // 1. Send API request to update payment
                                    await axiosInstance.put(`/paymentrecived/${invoice.id}`, {
                                      Payment_recieved: newValue
                                    });

                                    // 2. Update frontend state immediately
                                    setInvoices((prevInvoices) =>
                                      prevInvoices.map((inv) =>
                                        inv.id === invoice.id
                                          ? {
                                            ...inv,
                                            Payment_recieved: newValue,
                                            status: newValue ? "Paid" : "Pending" // Sync status with payment
                                          }
                                          : inv
                                      )
                                    );

                                    toast.success(newValue ? `Payment Recived Successfully` : `Payment status updated`);
                                  } catch (error) {
                                    console.error("Failed to update payment:", error);
                                    toast.error("Failed to update payment");
                                  }
                                }}
                              />
                            </td>
                            <td className="delete-action">
                              <button
                                onClick={() => handleDelete(invoice.id)}
                                style={{
                                  backgroundColor: "#ff4d4d",
                                  color: "white",
                                  border: "none",
                                  padding: "5px 10px",
                                  borderRadius: "4px",
                                  cursor: "pointer"
                                }}
                              >
                                Delete
                              </button>
                            </td>



                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="no-data">
                            <div className="no-invoices">
                              <div className="no-invoices-icon">📄</div>
                              <h3>No invoices found</h3>
                              <p>Try adjusting your search or filter criteria</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        ) : null}

        {/* <div className="invoices-summary">
          <div className="summary-card">
            <h4>Total Invoices</h4>
            <p className="summary-number">{invoices.length}</p>
          </div> */}
        {/* <div className="summary-card">
            <h4>Total Amount</h4>
            <p className="summary-number">
              {formatCurrency(invoices.reduce((sum, invoice) => sum + invoice.amount, 0))}
            </p>
          </div> */}
        {/* <div className="summary-card">
            <h4>Pending</h4>
            <p className="summary-number">
              {invoices.filter(inv => inv.status === 'Pending').length}
            </p>
          </div>
        </div> */}
      </div>

      <Footer />
    </>
  );
}

export default PolymatchInvoices;